export const OTP_LENGTH = 6;
export const OTP_RESEND_TIMER_IN_MINUTES = 3;
